(function () {
  "use strict";

// [module] src/runtime/modules/alert/AlertNotification.mjs
class AlertNotification {
  constructor() {
    this.notification = document.querySelector('.alert-notification');
    this.delayTime = 3500;
    this.timerId = null;
    this.isActive = false;
  }

  showMessage(message, type) {
    if (!this.notification) {
      return;
    }

    this.clearNotification();
    var parts = String(message || '').split('\n');
    for (var i = 0; i < parts.length; i++) {
      if (i > 0) {
        this.notification.appendChild(document.createElement('br'));
      }
      this.notification.appendChild(document.createTextNode(parts[i]));
    }
    this.notification.classList.add('active', type);
    this.isActive = true;

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    if (this.isActive && type === 'error') {
      this.notification.classList.add('shake');

      setTimeout(() => {
        this.notification.classList.remove('shake');
      }, 500);
    }

    this.timerId = setTimeout(() => {
      this.notification.classList.remove('active', type);
      this.isActive = false;
    }, this.delayTime);
  }

  success(message) {
    this.showMessage(message, 'success');
  }

  error(message) {
    this.showMessage(message, 'error');
  }

  warning(message) {
    this.showMessage(message, 'warning');
  }

  info(message) {
    this.showMessage(message, 'information');
  }

  clearNotification() {
    if (!this.notification) {
      return;
    }
    this.notification.replaceChildren();
    this.notification.classList.remove('active', 'success', 'error', 'warning', 'information');
  }
}

// [module] src/runtime/entries/alert-notification.mjs

window.alertNotification = new AlertNotification();

})();
